import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import Table from '../../../components/Table'
import Button from '../../../components/Button'
import { Input, Select } from '../../../components/ModalInputs'
import { BiTrash } from 'react-icons/bi'
import { getSubgroupHistoryTab } from '../../../actions/directoryBasicEducation'

const TERM_TYPES = [
  { id: 1, name: 'Четверть' },
  { id: 2, name: 'Полугодие' },
  { id: 3, name: 'Триместр' },
]

export default function HistoryTab({ values, setFieldValue, addMode, filters, editable = true, gid }) {
  const dispatch = useDispatch()
  const { schoolYears: yearList } = useSelector(state => state.common)
  const { subgroupHistory } = useSelector(state => state.directoryBasicEducation)

  // Загрузка данных при первом открытии вкладки
  useEffect(() => {
    if (gid && !addMode) {
      dispatch(getSubgroupHistoryTab(gid))
    }
  }, [gid, addMode])

  // Обновить значения формы при получении данных
  useEffect(() => {
    if (subgroupHistory?.data && !addMode && setFieldValue) {
      const historyData = subgroupHistory.data
      if (historyData.length > 0) {
        setFieldValue('history', historyData)
      }
    }
  }, [subgroupHistory, addMode])

  const historyData = values?.history || []
  const canEdit = addMode || editable

  // Добавить новую строку
  const handleAddRow = () => {
    const newRow = {
      school_year_id: filters?.xp_key || '',
      name: values?.main?.name || '',
      year: null,
      liter: '',
      term_type_id: 1
    }
    setFieldValue('history', [...historyData, newRow])
  }

  // Удалить строку
  const handleRemoveRow = (index) => {
    const newHistory = historyData.filter((_, i) => i !== index)
    setFieldValue('history', newHistory.length > 0 ? newHistory : [{
      school_year_id: filters?.xp_key || '',
      name: '',
      year: null,
      liter: '',
      term_type_id: 1
    }])
  }

  // Изменить значение в строке
  const handleChangeRow = (index, field, value) => {
    const newHistory = historyData.map((row, i) => {
      if (i === index) {
        return { ...row, [field]: value }
      }
      return row
    })
    setFieldValue('history', newHistory)
  }

  // Получить название года по id
  const getYearName = (yearId) => {
    const year = yearList?.find(y => y.xp_key === yearId)
    return year?.name || ''
  }

  return (
    <div className={styles.wrapper}>
      <Table className={styles.table}>
        <thead>
          <tr>
            <th style={{ width: '130px' }}>Учебный год</th>
            <th style={{ width: '180px' }}>Название</th>
            <th style={{ width: '100px' }}>Год обучения</th>
            <th style={{ width: '80px' }}>Литера</th>
            <th style={{ width: '130px' }}>Тип уч. периода</th>
            {canEdit && <th style={{ width: '50px' }}></th>}
          </tr>
        </thead>
        <tbody>
          {historyData.map((row, index) => (
            <tr key={index}>
              <td style={{ width: '130px' }}>
                {canEdit ? (
                  <Select
                    value={row.school_year_id}
                    onChange={(e) => handleChangeRow(index, 'school_year_id', Number(e.target.value))}
                    style={{ width: '100%' }}
                  >
                    <option value=''>Выберите</option>
                    {yearList?.map(year => (
                      <option key={year.xp_key} value={year.xp_key}>{year.name}</option>
                    ))}
                  </Select>
                ) : (
                  getYearName(row.school_year_id) || row.school_year
                )}
              </td>
              <td style={{ width: '180px' }}>
                {canEdit ? (
                  <Input
                    value={row.name}
                    onChange={(e) => handleChangeRow(index, 'name', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : (
                  row.name
                )}
              </td>
              <td style={{ width: '100px' }}>
                {canEdit ? (
                  <Input
                    type="number"
                    value={row.year || ''}
                    onChange={(e) => handleChangeRow(index, 'year', e.target.value ? Number(e.target.value) : null)}
                    style={{ width: '100%' }}
                  />
                ) : (
                  row.year
                )}
              </td>
              <td style={{ width: '80px' }}>
                {canEdit ? (
                  <Input
                    value={row.liter}
                    onChange={(e) => handleChangeRow(index, 'liter', e.target.value)}
                    style={{ width: '100%' }}
                  />
                ) : (
                  row.liter
                )}
              </td>
              <td style={{ width: '130px' }}>
                {canEdit ? (
                  <Select
                    value={row.term_type_id}
                    onChange={(e) => handleChangeRow(index, 'term_type_id', Number(e.target.value))}
                    style={{ width: '100%' }}
                  >
                    {TERM_TYPES.map(type => (
                      <option key={type.id} value={type.id}>{type.name}</option>
                    ))}
                  </Select>
                ) : (
                  TERM_TYPES.find(t => t.id === row.term_type_id)?.name || 'Четверть'
                )}
              </td>
              {canEdit && (
                <td style={{ width: '50px', textAlign: 'center' }}>
                  <button
                    type='button'
                    className={styles.histDel}
                    title='Удалить'
                    onClick={() => handleRemoveRow(index)}
                    disabled={historyData.length <= 1}
                  >
                    <BiTrash />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>

      {canEdit && (
        <Button
          style={{ padding: '8px 20px', marginTop: '12px' }}
          onClick={handleAddRow}
        >
          + Добавить
        </Button>
      )}
    </div>
  )
}
